import { handleActions, createAction } from 'redux-actions';
import { createSelector } from 'reselect';
import produce from 'immer';

const withPrefix = actionType => `SIGNUP_${actionType}`;

// -- Actions

export const submit = createAction(withPrefix('SUBMIT'));
export const submitSuccess = createAction(withPrefix('SUBMIT_SUCCESS'));
export const submitFail = createAction(withPrefix('SUBMIT_FAIL'));

export const actions = {
  submit,
  submitSuccess,
  submitFail,
};

// -- Reducer

const resetState = () => ({
  data: null,
  loading: false,
});

const reducer = handleActions({
  [submit]: state => produce(state, (draft) => {
    draft.data = null;
    draft.loading = true;
  }),
  [submitSuccess]: (state, action) => produce(state, (draft) => {
    draft.data = action.payload;
    draft.loading = false;
  }),
  [submitFail]: state => produce(state, (draft) => {
    draft.loading = false;
  }),
}, resetState());

export default reducer;

// -- Selectors

const signupSelector = state => state.signup;

export const dataSelector = createSelector(signupSelector, signup => signup.data);



// WEBPACK FOOTER //
// ./src/features/Signup/duck/signup-reducer.js